import React from 'react';

const REVIEWS = [
  { name: 'Priya Sharma',    city: 'Delhi',     rating: 5, text: 'Booked Delhi to Goa in under 2 minutes! The fare was ₹800 cheaper than any other site. FlightBooKaro is now my go-to app.', avatar: 'PS', trips: 12 },
  { name: 'Rahul Verma',     city: 'Mumbai',    rating: 5, text: 'Saved ₹2,400 on a round trip to Bangalore. The whole process was super smooth and I got my ticket on WhatsApp instantly!', avatar: 'RV', trips: 8  },
  { name: 'Ananya Iyer',     city: 'Bangalore', rating: 5, text: 'Used FlightBooKaro for my business trip to Hyderabad. Got a GST invoice automatically and the support team was amazing.', avatar: 'AI', trips: 22 },
  { name: 'Karan Mehta',     city: 'Hyderabad', rating: 5, text: 'The fare comparison is unbeatable. Found a flight at 35% less than the airline website. Will never book directly again!', avatar: 'KM', trips: 6  },
  { name: 'Sunita Patel',    city: 'Ahmedabad', rating: 5, text: 'Traveling with kids is stressful but FlightBooKaro made it easy. Seat selection, baggage add-on, all in one place.', avatar: 'SP', trips: 15 },
  { name: 'Vikram Singh',    city: 'Jaipur',    rating: 5, text: 'Booked for my parents\' pilgrimage trip. The senior support team helped with everything. Very trustworthy platform.', avatar: 'VS', trips: 4  },
];

const STARS = (n) => Array.from({ length: n }, (_, i) => (
  <span key={i} className="text-amber-400 text-sm">★</span>
));

export default function Testimonials() {
  return (
    <section className="py-14 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <span className="inline-block text-xs font-bold text-violet-600 uppercase tracking-widest bg-violet-50 border border-violet-100 px-4 py-1.5 rounded-full mb-3">
            Real Travelers. Real Savings.
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-3">Loved by 2 Million+</h2>
          <p className="text-gray-500 text-sm sm:text-base max-w-xl mx-auto">
            Indians trust FlightBooKaro for their travel plans — from weekend getaways to international adventures.
          </p>
        </div>

        {/* Review cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mb-10">
          {REVIEWS.map(r => (
            <div key={r.name} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md p-5 sm:p-6 transition-all">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-violet-600 to-amber-500 flex items-center justify-center text-white font-black text-sm shrink-0">
                  {r.avatar}
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.city} · {r.trips} trips booked</p>
                </div>
                <div className="ml-auto flex">{STARS(r.rating)}</div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">"{r.text}"</p>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-gradient-to-r from-[#1e1b4b] to-purple-900 rounded-2xl p-6 sm:p-8 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center text-white">
          {[
            { value: '4.8★', label: 'Average Rating', sub: 'from 50,000+ reviews' },
            { value: '2M+',  label: 'Happy Travelers', sub: 'and counting' },
            { value: '98%',  label: 'On-Time Tickets', sub: 'instant delivery' },
            { value: '₹850', label: 'Avg. Savings',    sub: 'per booking' },
          ].map(s => (
            <div key={s.label}>
              <p className="text-2xl sm:text-3xl font-black text-amber-400">{s.value}</p>
              <p className="text-white font-semibold text-sm mt-1">{s.label}</p>
              <p className="text-white/50 text-xs mt-0.5">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
